exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".partners h2 {\r\n  color: #84baac;\r\n}\r\n\r\n.partner-imgs {\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n}\r\n\r\n.partner-imgs img {\r\n  width: 150px;\r\n  height: 150px;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .partner-imgs img {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/partners/partners.component.css
// module id = ../../../../../src/app/components/home/partners/partners.component.css
// module chunks = main